import { useState } from "react";
import { faqs } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="scroll-mt-32 bg-background-100/70 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12">
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-32">
              <SectionHeading
                eyebrow="常见问题"
                icon="ri-question-answer-line"
                title="先弄明白，再决定看哪"
                desc="把最常被问到的几个问题集中在这里，包括分站与主站的区别、独立版块是什么、以及第一次来该从哪看起。"
              />
              <a
                href="#entry"
                className="mt-6 inline-flex items-center gap-2 h-11 px-5 rounded-md border border-background-300 bg-background-50 text-foreground-900 font-label text-sm hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                回到分站入口
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-up-line text-[14px]"></i>
                </span>
              </a>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="flex flex-col gap-3">
              {faqs.map((item, index) => {
                const isOpen = openIndex === index;
                return (
                  <div
                    key={item.q}
                    className={`rounded-lg border transition-colors ${
                      isOpen
                        ? "border-primary-300 bg-background-50"
                        : "border-background-200 bg-background-50"
                    }`}
                  >
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? -1 : index)}
                      aria-expanded={isOpen}
                      className="w-full flex items-center justify-between gap-4 px-5 py-5 text-left cursor-pointer"
                    >
                      <span className="flex items-center gap-3">
                        <span
                          className={`shrink-0 w-7 h-7 flex items-center justify-center rounded-md font-label text-xs ${
                            isOpen
                              ? "bg-primary-500 text-foreground-950"
                              : "bg-background-100 text-foreground-600"
                          }`}
                        >
                          {String(index + 1).padStart(2, "0")}
                        </span>
                        <span className="font-heading text-sm md:text-base font-semibold text-foreground-950">
                          {item.q}
                        </span>
                      </span>
                      <span className="shrink-0 w-7 h-7 flex items-center justify-center text-foreground-600">
                        <i
                          className={
                            isOpen
                              ? "ri-subtract-line text-[18px]"
                              : "ri-add-line text-[18px]"
                          }
                        ></i>
                      </span>
                    </button>
                    {isOpen && (
                      <div className="px-5 pb-5 pl-[3.75rem]">
                        <p className="font-body text-sm leading-relaxed text-foreground-600">
                          {item.a}
                        </p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}